export enum ObjectValidationRulesTypeEnum {
  UNIQUE_BETWEEN_FIELDS = 'UNIQUE_BETWEEN_FIELDS',
  REQUIRED = 'REQUIRED',
  MIN = 'MIN',
  MAX = 'MAX',
  ADVANCED = 'ADVANCED',
  BASIC = 'BASIC',
}
